import { Box, Typography } from "@mui/material";
import JoditEditor from "jodit-react";
import { useRef } from "react";
import CustomSnackbar from "../customSnackBar/customSnackBar";

export default function RichTextEditorPage({ title, value, onChange }) {
  const editor = useRef(null);
  const snackRef = useRef(null);

  const config = {
    readonly: false,
    height: 400,
    toolbar: true,
    spellcheck: false,
    language: "en",
    toolbarButtonSize: "medium",
    toolbarAdaptive: false,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    buttons: [
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "|",
      "fontsize",
      "font",
      "brush",
      "lineHeight", // Line Height Button Added
      "|",
      "ul",
      "ol",
      "|",
      "align",
      "undo",
      "redo",
      "|",
      "source",
    ],
    controls: {
      lineHeight: {
        list: ["0.5", "1", "1.15", "1.5", "2", "2.5", "3"], // Line height options
        default: "1", // Default line height
      },
    },
    colors: {
      background: "#ffffff",
      text: "#000000",
    },
    theme: "default",
    enableDragAndDropFileToEditor: true,
    saveFocusOnBlur: true,
    useSearch: false,
    editorCssClass: "custom-editor",
    fonts: {
      Arial: "Arial",
      Helvetica: "Helvetica",
      "Times New Roman": "Times New Roman",
      Roboto: "Roboto",
      Georgia: "Georgia",
      Verdana: "Verdana",
    },
    fontSize: {
      "8px": "8px",
      "10px": "10px",
      "12px": "12px",
      "14px": "14px",
      "16px": "16px",
      "18px": "18px",
      "20px": "20px",
      "24px": "24px",
      "36px": "36px",
    },
  };

  return (
    <Box
      sx={{ maxWidth: 960, mx: "auto", p: 2, bgcolor: "#fff", borderRadius: 2 }}
    >
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        onBlur={(newContent) => onChange(newContent)}
      />
      <CustomSnackbar ref={snackRef} />
    </Box>
  );
}
